import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import {
  useBuilderContext,
  useComponentContext,
  useBuilderConfigContext,
  usePanelContext,
  useRendererContext,
} from 'hb-builder/hooks';
import type { BuilderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

import PartnersSliderUI from './components/SliderUI';

const PartnersSlider: BuilderComponent<PartnersItemAttributes> = () => <div />; // never used

export interface PartnersSliderItem
  extends Omit<DocumentItem<PartnersItemAttributes>, 'children'> {
  children: PartnersSliderItem[];
  index?: number;
}

export interface PartnersSliderUIProps {
  item?: PartnersSliderItem;
  onClickCallBack?: (logo: PartnersSliderItem) => void;
  onDoubleClickCallBack?: (e: MouseEvent, logo: PartnersSliderItem) => void;
  subdomainNetworkUrl?: string;
  withImageSetter?: boolean;
}

const RenderBuilder = () => {
  const { getParentItem, updateAttribute } = useBuilderContext();
  const { item } = useComponentContext();
  const {
    hivebrite: { subdomainNetworkUrl },
  } = useBuilderConfigContext();
  const { displayPanel } = usePanelContext();

  const column = getParentItem(item.id);
  const parentComponent = getParentItem(column.id);

  const toggleDrawer = (logo) => {
    const isOpened = parentComponent.attributes.__isSelected === logo.id;

    if (isOpened) {
      return;
    }

    updateAttribute({
      id: parentComponent.id,
      attribute: '__isSelected',
      value: logo.id,
    });
  };

  return (
    <PartnersSliderUI
      item={item as PartnersSliderItem}
      onClickCallBack={toggleDrawer}
      onDoubleClickCallBack={(e, item) => {
        e.stopPropagation();
        displayPanel();
        toggleDrawer(item);
      }}
      subdomainNetworkUrl={subdomainNetworkUrl}
      withImageSetter
    />
  );
};

const Render = ({ item }: RenderProps<PartnersSliderItem>) => {
  const { subdomainNetworkUrl } = useRendererContext();

  return (
    <PartnersSliderUI item={item} subdomainNetworkUrl={subdomainNetworkUrl} />
  );
};

PartnersSlider.componentName = 'PartnersSlider';
PartnersSlider.componentType = 'single';

PartnersSlider.canBeDoubleClicked = false;
PartnersSlider.canBeDragged = false;
PartnersSlider.canBeListed = false;
PartnersSlider.canBeSelected = false;

PartnersSlider.RenderBuilder = RenderBuilder;
PartnersSlider.Render = Render;

PartnersSlider.item = ({ attributes, children }) => ({
  attributes,
  children,
  type: PartnersSlider.componentName,
});

export default PartnersSlider;
